import { FormattedMessage } from 'react-intl';

import { supplierGridProperties } from '../../data/suppliers-properties';
import { messages } from '../messages';

type SupplierData = {
  supplierEmail: string;
};

const name = <FormattedMessage {...messages.supplierEmailColumnHeader} />;

/**
 * Supplier Email column configuration
 * Displays the email address of the supplier
 */
export const supplierEmailColumn = {
  name,
  render: (data: SupplierData) => data.supplierEmail,
  id: supplierGridProperties.supplierEmail,
};
